<script>
  import rules from '@/helpers/validation-rules';
  import socials from '@/data/socials';

  export default {
    name: 'NotFound',

    //Return data as an object is proper vue.js method for defining components data
    data() {
      return {
        rules,
        socials,
        model: {
          name: '',
          email: '',
        },
        ytTrailer: false,
        isPreregistered: false,
      };
    },
    methods: {
      async subscribe() {
        try {
          let firstName = '';
          let lastName = '';
          const nameParts = this.model.name.split(' ');

          if (nameParts.length > 1) {
            firstName = nameParts[0];
            lastName = nameParts.slice(1).join(' ');
          } else {
            firstName = this.model.name;
          }

          const response = await fetch('https://comms-test.maxquestgame.com/subscribe', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              firstName,
              lastName,
              email: this.model.email,
            }),
          });

          if (response.ok) {
            // Subscription successful - handle success UI/logic
          } else {
            // Subscription failed - handle error UI/logic
          }
        } catch (error) {
          console.error('Error:', error);
        }
      },
    },
  };
</script>

<template>
  <div class="coming-soon-bg">
    <div class="d-flex flex-column align-center w-100 pt-10 pb-5">
      <img
        v-reload-on-fail
        loading="lazy"
        src="/images/logos/mq_logo_new.png"
        class="header-image d-flex justify-center px-10 px-md-0"
        alt
      />
      <span class="text-lg-h4 text-h6 text-center font-weight-800 mt-2 px-5 pb-15 pb-sm-10">
        Play Games of Skill to Win Real Cash Prizes
      </span>
    </div>
    <div v-if="isPreregistered" class="thanks-container">
      <v-container class="d-flex align-center flex-column">
        <img v-reload-on-fail loading="lazy" src="/images/logos/thanks-text.png" alt />
        <span class="text-xl-h4 text-sm-h5 text-h6 text-center font-weight-600">
          Remember to check your email on launch day for 25 FREE Max Coins.
        </span>
        <div class="w-100 d-flex flex-column align-center mt-10">
          <span class="text-subtitle-1 mb-3 font-weight-600">FOLLOW US ON SOCIAL MEDIA</span>
          <div class="social-links">
            <a :href="socials.facebookUrl" class="link" target="_blank">
              <img v-reload-on-fail loading="lazy" src="/images/svgs/Facebook.svg" width="40" height="40" alt="" />
            </a>
            <a :href="socials.instagramUrl" class="link" target="_blank">
              <img v-reload-on-fail loading="lazy" src="/images/svgs/Insta.svg" width="40" height="40" alt="" />
            </a>
            <a :href="socials.twitchUrl" class="link" target="_blank">
              <img v-reload-on-fail loading="lazy" src="/images/svgs/Twitch.svg" width="40" height="40" alt="" />
            </a>
            <a :href="`${socials.youtubeUrl}/videos`" class="link" target="_blank">
              <img v-reload-on-fail loading="lazy" src="/images/svgs/YouTube.svg" width="40" height="40" alt="" />
            </a>
            <a :href="socials.tiktokUrl" class="link" target="_blank">
              <img v-reload-on-fail loading="lazy" src="/images/svgs/TikTok.svg" width="40" height="40" alt="" />
            </a>
            <a :href="socials.twitterUrl" class="link" target="_blank">
              <img v-reload-on-fail loading="lazy" src="/images/svgs/X.svg" width="40" height="40" alt="" />
            </a>
          </div>
        </div>
        <div v-if="isPreregistered" class="discord-ribbon w-70 d-flex flex-column align-center">
          <a :href="socials.discordUrl" target="_blank" class="discord-link text-subtitle-1">
            JOIN OUR DISCORD COMMUNITY
          </a>
          <img
            v-reload-on-fail
            loading="lazy"
            src="/images/logos/discord-logo-transparent.png"
            class="discord-logo"
            alt=""
          />
        </div>
      </v-container>
    </div>
    <div v-if="!isPreregistered" class="inputs-container mt-15">
      <img v-reload-on-fail loading="lazy" class="coming-soon-ribbon" src="/images/logos/coming-soon.png" alt="" />
      <v-container class="d-flex align-center flex-column pt-15">
        <span class="text-md-h4 text-sm-h5 text-h6 text-center font-weight-800 mt-sm-5">
          Get your
          <span class="white--text">FREE $25*</span>
          on mm/dd/yyyy!
        </span>
        <span class="text-md-h5 text-sm-h6 text-subtitle-1 text-center font-weight-600 mt-sm-5 mt-2">
          Be among the first to play the #1 Player vs Player action games.
        </span>
        <v-row class="w-100 mt-5">
          <v-col cols="12" sm="6" class="d-flex flex-column align-end pb-0">
            <v-text-field
              v-model="model.name"
              :rules="[rules.name()]"
              placeholder="Name"
              persistent-placeholder
              outlined
              class="customInput w-100 pr-md-5 pr-0 pl-md-10 pl-0"
            />
            <v-dialog
              v-if="!$vuetify.breakpoint.xs"
              v-model="ytTrailer"
              width="100%"
              max-width="1200px"
              content-class="yt-trailer"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="border-doubled main-lighter large white--text mr-md-6 mt-10" v-bind="attrs" v-on="on">
                  watch trailer
                </v-btn>
              </template>
              <v-card>
                <iframe
                  v-if="ytTrailer"
                  width="100%"
                  src="https://www.youtube.com/embed/4_pnqG7reLE?color=red&showinfo=0&loop=0&rel=0&start=0&cc_load_policy=0&iv_load_policy=3&enablejsapi=1&autoplay=1"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  style="border: 0"
                />
                <v-btn color="primary" text class="close-btn-modal" @click="ytTrailer = false">x</v-btn>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="6" class="pb-0">
            <v-text-field
              v-model="model.email"
              :rules="[rules.email()]"
              placeholder="Email address"
              persistent-placeholder
              outlined
              class="customInput pl-md-5 pr-md-10 pr-0 pl-0"
            />
            <v-btn
              @click="subscribe"
              v-if="!$vuetify.breakpoint.xs"
              class="border-doubled gold large white--text ml-md-6 mt-10"
            >
              pre-register now
            </v-btn>
          </v-col>
          <v-col cols="12" class="buttons-container d-flex flex-column mt-3" v-if="$vuetify.breakpoint.xs">
            <v-btn class="border-doubled gold small white--text">pre-register now</v-btn>
            <v-dialog v-model="ytTrailer" width="100%" max-width="1200px" content-class="yt-trailer">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="border-doubled main-lighter small white--text mt-5" v-bind="attrs" v-on="on">
                  watch trailer
                </v-btn>
              </template>
              <v-card>
                <iframe
                  v-if="ytTrailer"
                  width="100%"
                  src="https://www.youtube.com/embed/4_pnqG7reLE?color=red&showinfo=0&loop=0&rel=0&start=0&cc_load_policy=0&iv_load_policy=3&enablejsapi=1&autoplay=1"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
                <v-btn color="primary" text class="close-btn-modal" @click="ytTrailer = false">x</v-btn>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
        <div
          v-if="!isPreregistered"
          class="footer-text w-70 mx-auto d-flex flex-column text-center text-subtitle-2 text-md-subtitle-1 py-2"
        >
          <span>
            You will receive an email with a registration link on launch day.
            <br v-if="!$vuetify.breakpoint.xs" />
            Sign up via the link to receive 25 FREE MC. No purchase necessary.
            <br />
            1MC = 1USD
          </span>
        </div>
      </v-container>
    </div>
    <img
      v-reload-on-fail
      loading="lazy"
      v-if="!$vuetify.breakpoint.smAndDown"
      src="/images/figures/Woman.png"
      class="figure-1"
      alt=""
    />
    <img
      v-reload-on-fail
      loading="lazy"
      v-if="!$vuetify.breakpoint.smAndDown"
      src="/images/figures/Man.png"
      class="figure-2"
      alt=""
    />
  </div>
</template>

<style scoped>
  .coming-soon-bg {
    background-image: url('/images/backgrounds/coming-soon-bgr.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    position: relative;
    height: 100%;
    padding-bottom: 150px;

    .footer-text {
      position: absolute;
      bottom: -120px;
      background: linear-gradient(
        90deg,
        rgba(110, 94, 123, 0) 0%,
        rgba(110, 94, 123, 1) 50%,
        rgba(110, 94, 123, 0) 100%
      );
    }

    .figure-1 {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 22%;
    }

    .figure-2 {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 20%;
    }

    .header-image {
      max-width: 450px;
      min-width: 100px;
      width: 100%;
    }

    .thanks-container {
      position: relative;
      top: 25%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 75%;
      max-width: 1400px;
      height: 300px;
      background: linear-gradient(145deg, rgba(132, 118, 179, 1) 0%, rgba(46, 32, 58, 1) 100%);
      border-radius: 10px;

      .social-links {
        display: flex;
        gap: 25px;
        align-items: center;

        .link:hover {
          opacity: 0.6;
        }
      }
    }

    .discord-ribbon {
      position: absolute;
      overflow: hidden;
      height: 60px;
      bottom: -120px;
      background: linear-gradient(
        90deg,
        rgba(110, 94, 123, 0) 0%,
        rgba(110, 94, 123, 1) 50%,
        rgba(110, 94, 123, 0) 100%
      );

      .discord-logo {
        position: absolute;
        height: 100px;
        opacity: 0.1;
        top: 50%;
        transform: translate(0, -50%) rotate(-9deg);
      }

      .discord-link {
        width: 100%;
        text-align: center;
        font-weight: 600;
        text-decoration: underline;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .inputs-container {
      position: relative;
      top: 25%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 75%;
      max-width: 1400px;
      height: 350px;
      background: linear-gradient(145deg, rgba(132, 118, 179, 1) 0%, rgba(46, 32, 58, 1) 100%);
      border-radius: 10px;

      .coming-soon-ribbon {
        left: 50%;
        top: -120px;
        transform: translate(-50%, 0);
        position: absolute;
        width: 100%;
        max-width: 350px;
      }

      .customInput {
        .v-input__control {
          .v-text-field__details {
            position: absolute;
            bottom: -25px;
          }

          .v-input__slot {
            background: white;
            .v-text-field__slot > input::placeholder {
              color: black !important;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 960px) {
    .buttons-container {
      max-width: 280px;
      margin: 0 auto;
    }

    .inputs-container {
      height: 350px !important;
      width: 90% !important;
    }

    .discord-ribbon {
      width: 90% !important;
    }

    .footer-text {
      width: 90% !important;
    }
  }

  @media screen and (max-width: 600px) {
    .coming-soon-bg {
      background-image: url('/images/backgrounds/coming-soon-bgr-mobile.png') !important;
      padding-bottom: 100px;
    }

    .discord-ribbon {
      bottom: -100px !important;
    }

    .footer-text {
      bottom: -100px !important;
    }

    .thanks-container {
      width: 90% !important;
      height: 250px !important;
    }

    .inputs-container {
      width: 90% !important;
      height: 420px !important;
    }

    .buttons-container {
      max-width: 200px;
      margin: 0 auto;
    }

    .coming-soon-ribbon {
      top: -100px !important;
      max-width: 275px !important;
    }
  }
</style>
